import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import './LandingPage.css';

export default function LandingPage() {
  const navigate = useNavigate();
  const [raffle, setRaffle] = useState(null);
  const [ticketsAvailable, setTicketsAvailable] = useState(1000);
  const [soldTickets, setSoldTickets] = useState(0);

  useEffect(() => {
    const fetchRaffle = async () => {
      try {
        const data = await api.getActiveRaffle();
        if (data) {
          setRaffle(data);
          setTicketsAvailable(data.total_tickets - data.sold_tickets);
          setSoldTickets(data.sold_tickets);
        }
      } catch (error) {
        console.log('No active raffle');
      }
    };
    fetchRaffle();
    
    // Refresh every 30 seconds
    const interval = setInterval(fetchRaffle, 30000);
    return () => clearInterval(interval);
  }, []);

  const handleBuyClick = () => {
    navigate('/register');
  };

  const progressPercentage = raffle 
    ? Math.round((raffle.sold_tickets / raffle.total_tickets) * 100) 
    : 5;

  return (
    <div className="landing-body">
      <div className="landing-container">
        <div className="showcase">
          <div className="left-section">
            <div className="logo-section">
              <div className="logo-text">
                Tu <span className="prima">Prima</span>
              </div>
              <div className="tagline">LA QUE ALEGRA EL DÍA</div>
            </div>

            <h1 className="main-title">
              ¡Gana hasta<br />$1.000.000!
            </h1>

            <p className="subtitle">
              La app de sorteos más emocionante de Colombia
            </p>

            <div className="benefits">
              <div className="benefit-item">
                <div className="benefit-icon">🎟️</div>
                <div className="benefit-text">Tickets desde $2.500 - ¡Súper accesible!</div>
              </div>
              <div className="benefit-item">
                <div className="benefit-icon">🏆</div>
                <div className="benefit-text">Sorteos diarios con premios reales</div>
              </div>
              <div className="benefit-item">
                <div className="benefit-icon">⚡</div>
                <div className="benefit-text">Resultados instantáneos al 100%</div>
              </div>
              <div className="benefit-item">
                <div className="benefit-icon">💰</div>
                <div className="benefit-text">Múltiples categorías de premios</div>
              </div>
            </div>

            <div className="cta-section">
              <div className="prize-highlight">
                <div className="prize-label">PREMIO MAYOR</div>
                <div className="prize-amount">$1.000.000</div>
              </div>
              <button 
                className="cta-button" 
                onClick={handleBuyClick}
                data-testid="landing-cta-button"
              >
                ¡Comprar Tickets Ahora! →
              </button>
            </div>
          </div>

          <div className="right-section">
            <div className="phone-mockup">
              <div className="phone-screen">
                {/* App Header */}
                <div className="phone-header">
                  <div className="phone-logo">Tu Prima</div>
                  <div className="phone-tagline">LA QUE ALEGRA EL DÍA</div>
                </div>

                {/* Prize Card */}
                <div className="phone-card">
                  <div className="phone-card-title">
                    {raffle?.name || 'Sorteo Activo'}
                  </div>
                  <div className="phone-card-prize">$1.000.000</div>
                  <div className="phone-card-subtitle">Premio Mayor</div>
                  <div className="phone-card-text">Hoy alguien gana</div>
                  <div className="phone-card-text-small">Puede ser tu prima...</div>
                </div>

                {/* CTA Button in Phone */}
                <button
                  className="phone-cta"
                  onClick={handleBuyClick}
                  data-testid="landing-phone-cta"
                >
                  ¡Comprar Tickets!
                </button>

                {/* Price */}
                <div className="phone-price">
                  Precio por ticket: $2.500
                </div>

                {/* Progress */}
                <div className="phone-progress-container">
                  <div className="phone-progress-bar">
                    <div 
                      className="phone-progress-fill"
                      style={{ width: `${progressPercentage}%` }}
                    />
                  </div>
                  <div className="phone-progress-text">
                    {raffle 
                      ? `${soldTickets}/${raffle.total_tickets} vendidos (${progressPercentage}%)`
                      : 'Sorteo en curso'}
                  </div>
                </div>

                {/* Footer */}
                <div className="phone-footer">tuprima.com</div>
              </div>
            </div>

            {/* Floating Badges */}
            <div className="floating-badge badge-1" data-testid="tickets-available-badge">
              {ticketsAvailable} tickets disponibles
            </div>

            <div className="floating-badge badge-2">
              {raffle?.status === 'active' ? 'Sorteo En Curso' : 'Próximamente'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
